import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { api } from "../../../services/api/axios";


// fetch payout
const fetchPayout = async ({ page, limit, search }) => {
  const response = await api.get("/v1/admin/personal/manual-review-payouts", {
    params: { page, limit, ...(search && { search }) },
  });
  return response.data;
};

export const usePayout = (page = 1, limit = 10, search = "") => {
  return useQuery({
    queryKey: ["payout", page, limit, search],
    queryFn: () => fetchPayout({ page, limit, search }),
    // Keep the previous page on screen while the next one loads.
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};

// approve payout
const approvePayout = async (payload) => {
  const { data } = await api.post(
    "/v1/admin/personal/approve-payout",
    payload
  );
  return data;
};

export const useApprovePayout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approvePayout,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payout"] });
    },
  });
};

// decline payout
const declinePayout = async (payload) => {
  const { data } = await api.post(
    "/v1/admin/personal/decline-payout",
    payload
  );
  return data;
};

export const useDeclinePayout = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: declinePayout,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payout"] });
    },
  });
};